function _array_like_to_array(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _array_with_holes(arr) {
  if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
  if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _iterable_to_array(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _non_iterable_rest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _sliced_to_array(arr, i) {
  return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
  return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _array_like_to_array(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { useLocation } from "@custom/schema";
import { debounce } from "es-toolkit";
import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import { clearTimeout, setInterval, setTimeout } from "worker-timers";
import { appConfig } from "../../../utils/app-config";
import { DOMAINS, useDomain } from "../../../utils/domain";
import { useLocalization } from "../../../utils/localization";
import { buildUrl, isRelativeUrl } from "../../../utils/url";
export function SEO(param) {
  var organicTitle = param.title,
    organicLinks = param.links,
    organicMeta = param.meta;
  var _fixedMetatags_loc_pathname, _fixedMetatags_loc_pathname1, _fixedMetatags_loc_pathname2;
  var isPreview = appConfig().isPreview;
  var _useLocation = _sliced_to_array(useLocation(), 1),
    loc = _useLocation[0];
  var domain = useDomain();
  var _useTranslation = useTranslation(),
    t = _useTranslation.i18n.t;
  var locale = useLocalization().locale;
  var title = organicTitle || ((_fixedMetatags_loc_pathname = fixedMetatags[loc.pathname]) === null || _fixedMetatags_loc_pathname === void 0 ? void 0 : _fixedMetatags_loc_pathname.title);
  var meta = organicMeta && organicMeta.length ? organicMeta : ((_fixedMetatags_loc_pathname1 = fixedMetatags[loc.pathname]) === null || _fixedMetatags_loc_pathname1 === void 0 ? void 0 : _fixedMetatags_loc_pathname1.meta) || [];
  var links = organicLinks && organicLinks.length ? organicLinks : (_fixedMetatags_loc_pathname2 = fixedMetatags[loc.pathname]) === null || _fixedMetatags_loc_pathname2 === void 0 ? void 0 : _fixedMetatags_loc_pathname2.links;
  if (isPreview) {
    meta.push({
      name: "google-site-verification",
      content: "bY6S_ndob9EqdqOoJxmphiVtBTPXKcAet25vta1qEyc"
    }, {
      name: "robots",
      content: "noindex, nofollow"
    });
  }
  var organizationUrl = "https://".concat(DOMAINS["paraplegie_ch"].host, "/");
  var localizedDomainUrl = "https://".concat(DOMAINS["paraplegie_ch"].host).concat(domain.pathPrefix, "/").concat(locale, "/");
  var schemaOrg = {
    "@context": "https://schema.org",
    "@graph": [{
      "@type": "Organization",
      "@id": "".concat(organizationUrl, "#organization"),
      url: organizationUrl,
      name: t(DOMAINS["paraplegie_ch"].title)
    }, {
      "@type": "WebSite",
      "@id": "".concat(localizedDomainUrl, "#website"),
      url: localizedDomainUrl,
      name: t(domain.title),
      inLanguage: locale,
      publisher: {
        "@id": "".concat(organizationUrl, "#organization")
      }
    }]
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Helmet, {
    titleTemplate: "%s",
    defaultTitle: t(domain.title),
    htmlAttributes: {
      lang: locale
    }
  }, title && /*#__PURE__*/React.createElement("title", null, title), links && links.map(function (link) {
    if (!["shortlink", "canonical"].includes(link.rel)) {
      return link;
    }
    return _object_spread_props(_object_spread({}, link), {
      href: isRelativeUrl(link.href) ? buildUrl(["".concat(domain.protocol).concat(domain.host)].concat(_to_consumable_array(link.href.split("/")))) : link.href
    });
  }).map(function (param, index) {
    var rel = param.rel,
      href = param.href;
    return /*#__PURE__*/React.createElement("link", {
      key: "link-".concat(index),
      rel: rel,
      href: href
    });
  }), meta && meta.map(function (item) {
    if (item.name !== "og:url") {
      return item;
    }
    return _object_spread_props(_object_spread({}, item), {
      content: isRelativeUrl(item.content) ? buildUrl(["".concat(domain.protocol).concat(domain.host)].concat(_to_consumable_array(item.content.split("/")))) : item.content
    });
  }).map(function (param, index) {
    var name = param.name,
      content = param.content;
    // This is needed for LinkedIn.
    if (name.includes("og:")) {
      return /*#__PURE__*/React.createElement("meta", {
        key: "meta-".concat(index),
        property: name,
        name: name,
        content: content
      });
    } else if (content !== "") {
      return /*#__PURE__*/React.createElement("meta", {
        key: "meta-".concat(index),
        name: name,
        content: content
      });
    }
  }), /*#__PURE__*/React.createElement("meta", {
    httpEquiv: "Content-Language",
    content: locale
  }), /*#__PURE__*/React.createElement("meta", {
    name: "viewport",
    content: "width=device-width"
  }), /*#__PURE__*/React.createElement("meta", {
    name: "robots",
    content: "index, follow"
  }), /*#__PURE__*/React.createElement("script", {
    type: "application/ld+json"
  }, JSON.stringify(schemaOrg)), /*#__PURE__*/React.createElement("noscript", null, "\n          <style>.motion-fade-in {opacity:1!important}</style>\n          ")), /*#__PURE__*/React.createElement(Favicons, {
    domain: domain,
    animated: typeof window === "undefined" || !window.localStorage.getItem("no-animated-favicon")
  }));
}
var fixedMetatags = {
  "/en/blog/": {
    title: "Blog | Swiss Paraplegic Group",
    meta: [{
      name: "referrer",
      content: "origin"
    }],
    links: [{
      rel: "canonical",
      href: "/en/blog/"
    }]
  },
  "/de/blog/": {
    title: "Blog | Swiss Paraplegic Group",
    meta: [{
      name: "referrer",
      content: "origin"
    }],
    links: [{
      rel: "canonical",
      href: "/de/blog/"
    }]
  },
  "/fr/blog/": {
    title: "Blog | Swiss Paraplegic Group",
    meta: [{
      name: "referrer",
      content: "origin"
    }],
    links: [{
      rel: "canonical",
      href: "/fr/blog/"
    }]
  },
  "/it/blog/": {
    title: "Blog | Swiss Paraplegic Group",
    meta: [{
      name: "referrer",
      content: "origin"
    }],
    links: [{
      rel: "canonical",
      href: "/it/blog/"
    }]
  },
  "/en/blog/all/": {
    title: "Blog | Swiss Paraplegic Group",
    meta: [{
      name: "referrer",
      content: "origin"
    }],
    links: [{
      rel: "canonical",
      href: "/en/blog/"
    }]
  },
  "/de/blog/all/": {
    title: "Blog | Swiss Paraplegic Group",
    meta: [{
      name: "referrer",
      content: "origin"
    }],
    links: [{
      rel: "canonical",
      href: "/de/blog/"
    }]
  },
  "/fr/blog/all/": {
    title: "Blog | Swiss Paraplegic Group",
    meta: [{
      name: "referrer",
      content: "origin"
    }],
    links: [{
      rel: "canonical",
      href: "/fr/blog/"
    }]
  },
  "/it/blog/all/": {
    title: "Blog | Swiss Paraplegic Group",
    meta: [{
      name: "referrer",
      content: "origin"
    }],
    links: [{
      rel: "canonical",
      href: "/it/blog/"
    }]
  },
  "/en/events/": {
    title: "Events | Swiss Paraplegic Group",
    meta: [{
      name: "referrer",
      content: "origin"
    }],
    links: [{
      rel: "canonical",
      href: "/en/events/"
    }]
  },
  "/de/events/": {
    title: "Events | Swiss Paraplegic Group",
    meta: [{
      name: "referrer",
      content: "origin"
    }],
    links: [{
      rel: "canonical",
      href: "/de/events/"
    }]
  },
  "/fr/events/": {
    title: "Events | Swiss Paraplegic Group",
    meta: [{
      name: "referrer",
      content: "origin"
    }],
    links: [{
      rel: "canonical",
      href: "/fr/events/"
    }]
  },
  "/it/events/": {
    title: "Events | Swiss Paraplegic Group",
    meta: [{
      name: "referrer",
      content: "origin"
    }],
    links: [{
      rel: "canonical",
      href: "/it/events/"
    }]
  },
  "/en/events/all/": {
    title: "Events | Swiss Paraplegic Group",
    meta: [{
      name: "referrer",
      content: "origin"
    }],
    links: [{
      rel: "canonical",
      href: "/en/events/"
    }]
  },
  "/de/events/all/": {
    title: "Events | Swiss Paraplegic Group",
    meta: [{
      name: "referrer",
      content: "origin"
    }],
    links: [{
      rel: "canonical",
      href: "/de/events/"
    }]
  },
  "/fr/events/all/": {
    title: "Events | Swiss Paraplegic Group",
    meta: [{
      name: "referrer",
      content: "origin"
    }],
    links: [{
      rel: "canonical",
      href: "/fr/events/"
    }]
  },
  "/it/events/all/": {
    title: "Events | Swiss Paraplegic Group",
    meta: [{
      name: "referrer",
      content: "origin"
    }],
    links: [{
      rel: "canonical",
      href: "/it/events/"
    }]
  },
  "/en/history/": {
    title: "History | Swiss Paraplegic Group",
    meta: [{
      name: "referrer",
      content: "origin"
    }],
    links: [{
      rel: "canonical",
      href: "/en/history/"
    }]
  },
  "/de/history/": {
    title: "History | Swiss Paraplegic Group",
    meta: [{
      name: "referrer",
      content: "origin"
    }],
    links: [{
      rel: "canonical",
      href: "/de/history/"
    }]
  },
  "/fr/history/": {
    title: "History | Swiss Paraplegic Group",
    meta: [{
      name: "referrer",
      content: "origin"
    }],
    links: [{
      rel: "canonical",
      href: "/fr/history/"
    }]
  },
  "/it/history/": {
    title: "History | Swiss Paraplegic Group",
    meta: [{
      name: "referrer",
      content: "origin"
    }],
    links: [{
      rel: "canonical",
      href: "/it/history/"
    }]
  },
  "/en/news/": {
    title: "News | Swiss Paraplegic Group",
    meta: [{
      name: "referrer",
      content: "origin"
    }],
    links: [{
      rel: "canonical",
      href: "/en/news/"
    }]
  },
  "/de/news/": {
    title: "News | Swiss Paraplegic Group",
    meta: [{
      name: "referrer",
      content: "origin"
    }],
    links: [{
      rel: "canonical",
      href: "/de/news/"
    }]
  },
  "/fr/news/": {
    title: "News | Swiss Paraplegic Group",
    meta: [{
      name: "referrer",
      content: "origin"
    }],
    links: [{
      rel: "canonical",
      href: "/fr/news/"
    }]
  },
  "/it/news/": {
    title: "News | Swiss Paraplegic Group",
    meta: [{
      name: "referrer",
      content: "origin"
    }],
    links: [{
      rel: "canonical",
      href: "/it/news/"
    }]
  },
  "/en/search/": {
    title: "Search | Swiss Paraplegic Group",
    meta: [{
      name: "referrer",
      content: "origin"
    }],
    links: [{
      rel: "canonical",
      href: "/en/search/"
    }]
  },
  "/de/search/": {
    title: "Suche | Swiss Paraplegic Group",
    meta: [{
      name: "referrer",
      content: "origin"
    }],
    links: [{
      rel: "canonical",
      href: "/de/search/"
    }]
  },
  "/fr/search/": {
    title: "Recherche | Swiss Paraplegic Group",
    meta: [{
      name: "referrer",
      content: "origin"
    }],
    links: [{
      rel: "canonical",
      href: "/fr/search/"
    }]
  },
  "/it/search/": {
    title: "Cerca | Swiss Paraplegic Group",
    meta: [{
      name: "referrer",
      content: "origin"
    }],
    links: [{
      rel: "canonical",
      href: "/it/search/"
    }]
  },
  "/sps/en/search/": {
    title: "Search | Swiss Paraplegic Foundation",
    meta: [{
      name: "referrer",
      content: "origin"
    }],
    links: [{
      rel: "canonical",
      href: "/sps/en/search/"
    }]
  },
  "/spz/en/search/": {
    title: "Search | Swiss Paraplegic Centre",
    meta: [{
      name: "referrer",
      content: "origin"
    }],
    links: [{
      rel: "canonical",
      href: "/spz/en/search/"
    }]
  },
  "/gv/en/search/": {
    title: "Search | Benefactors Association",
    meta: [{
      name: "referrer",
      content: "origin"
    }],
    links: [{
      rel: "canonical",
      href: "/gv/en/search/"
    }]
  },
  "/spf/en/search/": {
    title: "Search | Swiss Paraplegic Research",
    meta: [{
      name: "referrer",
      content: "origin"
    }],
    links: [{
      rel: "canonical",
      href: "/spf/en/search/"
    }]
  },
  "/sportmedizin/en/search/": {
    title: "Search | Sports Medicine Nottwil",
    meta: [{
      name: "referrer",
      content: "origin"
    }],
    links: [{
      rel: "canonical",
      href: "/sportmedizin/en/search/"
    }]
  },
  "/activecommunication/en/search/": {
    title: "Search | Active Communication",
    meta: [{
      name: "referrer",
      content: "origin"
    }],
    links: [{
      rel: "canonical",
      href: "/activecommunication/en/search/"
    }]
  },
  "/sirmed/en/search/": {
    title: "Search | Sirmed",
    meta: [{
      name: "referrer",
      content: "origin"
    }],
    links: [{
      rel: "canonical",
      href: "/sirmed/en/search/"
    }]
  },
  "/parahelp/en/search/": {
    title: "Search | ParaHelp",
    meta: [{
      name: "referrer",
      content: "origin"
    }],
    links: [{
      rel: "canonical",
      href: "/parahelp/en/search/"
    }]
  },
  "/orthotec/en/search/": {
    title: "Search | Orthotec",
    meta: [{
      name: "referrer",
      content: "origin"
    }],
    links: [{
      rel: "canonical",
      href: "/orthotec/en/search/"
    }]
  },
  "/sps/de/search/": {
    title: "Suche | Schweizer Paraplegiker-Stiftung",
    meta: [{
      name: "referrer",
      content: "origin"
    }],
    links: [{
      rel: "canonical",
      href: "/sps/de/search/"
    }]
  },
  "/spz/de/search/": {
    title: "Suche | Schweizer Paraplegiker-Zentrum",
    meta: [{
      name: "referrer",
      content: "origin"
    }],
    links: [{
      rel: "canonical",
      href: "/spz/de/search/"
    }]
  },
  "/gv/de/search/": {
    title: "Suche | G\xf6nner-Vereinigung",
    meta: [{
      name: "referrer",
      content: "origin"
    }],
    links: [{
      rel: "canonical",
      href: "/gv/de/search/"
    }]
  },
  "/spf/de/search/": {
    title: "Suche | Schweizer Paraplegiker-Forschung",
    meta: [{
      name: "referrer",
      content: "origin"
    }],
    links: [{
      rel: "canonical",
      href: "/spf/de/search/"
    }]
  },
  "/sportmedizin/de/search/": {
    title: "Suche | Sportmedizin Nottwil",
    meta: [{
      name: "referrer",
      content: "origin"
    }],
    links: [{
      rel: "canonical",
      href: "/sportmedizin/de/search/"
    }]
  },
  "/activecommunication/de/search/": {
    title: "Suche | Active Communication",
    meta: [{
      name: "referrer",
      content: "origin"
    }],
    links: [{
      rel: "canonical",
      href: "/activecommunication/de/search/"
    }]
  },
  "/sirmed/de/search/": {
    title: "Suche | Sirmed",
    meta: [{
      name: "referrer",
      content: "origin"
    }],
    links: [{
      rel: "canonical",
      href: "/sirmed/de/search/"
    }]
  },
  "/parahelp/de/search/": {
    title: "Suche | ParaHelp",
    meta: [{
      name: "referrer",
      content: "origin"
    }],
    links: [{
      rel: "canonical",
      href: "/parahelp/de/search/"
    }]
  },
  "/orthotec/de/search/": {
    title: "Suche | Orthotec",
    meta: [{
      name: "referrer",
      content: "origin"
    }],
    links: [{
      rel: "canonical",
      href: "/orthotec/de/search/"
    }]
  },
  "/sps/fr/search/": {
    title: "Recherche | Fondation suisse pour parapl\xe9giques",
    meta: [{
      name: "referrer",
      content: "origin"
    }],
    links: [{
      rel: "canonical",
      href: "/sps/fr/search/"
    }]
  },
  "/spz/fr/search/": {
    title: "Recherche | Centre suisse des parapl\xe9giques",
    meta: [{
      name: "referrer",
      content: "origin"
    }],
    links: [{
      rel: "canonical",
      href: "/spz/fr/search/"
    }]
  },
  "/gv/fr/search/": {
    title: "Recherche | Association des bienfaiteurs",
    meta: [{
      name: "referrer",
      content: "origin"
    }],
    links: [{
      rel: "canonical",
      href: "/gv/fr/search/"
    }]
  },
  "/spf/fr/search/": {
    title: "Recherche | Recherche suisse pour parapl\xe9giques",
    meta: [{
      name: "referrer",
      content: "origin"
    }],
    links: [{
      rel: "canonical",
      href: "/spf/fr/search/"
    }]
  },
  "/sportmedizin/fr/search/": {
    title: "Recherche | M\xe9decine du sport Nottwil",
    meta: [{
      name: "referrer",
      content: "origin"
    }],
    links: [{
      rel: "canonical",
      href: "/sportmedizin/fr/search/"
    }]
  },
  "/activecommunication/fr/search/": {
    title: "Recherche | Active Communication",
    meta: [{
      name: "referrer",
      content: "origin"
    }],
    links: [{
      rel: "canonical",
      href: "/activecommunication/fr/search/"
    }]
  },
  "/sirmed/fr/search/": {
    title: "Recherche | Sirmed",
    meta: [{
      name: "referrer",
      content: "origin"
    }],
    links: [{
      rel: "canonical",
      href: "/sirmed/fr/search/"
    }]
  },
  "/parahelp/fr/search/": {
    title: "Recherche | ParaHelp",
    meta: [{
      name: "referrer",
      content: "origin"
    }],
    links: [{
      rel: "canonical",
      href: "/parahelp/fr/search/"
    }]
  },
  "/orthotec/fr/search/": {
    title: "Recherche | Orthotec",
    meta: [{
      name: "referrer",
      content: "origin"
    }],
    links: [{
      rel: "canonical",
      href: "/orthotec/fr/search/"
    }]
  },
  "/sps/it/search/": {
    title: "Cerca | Fondazione svizzera per paraplegici",
    meta: [{
      name: "referrer",
      content: "origin"
    }],
    links: [{
      rel: "canonical",
      href: "/sps/it/search/"
    }]
  },
  "/spz/it/search/": {
    title: "Cerca | Centro svizzero per paraplegici",
    meta: [{
      name: "referrer",
      content: "origin"
    }],
    links: [{
      rel: "canonical",
      href: "/spz/it/search/"
    }]
  },
  "/gv/it/search/": {
    title: "Cerca | Unione dei sostenitori",
    meta: [{
      name: "referrer",
      content: "origin"
    }],
    links: [{
      rel: "canonical",
      href: "/gv/it/search/"
    }]
  },
  "/spf/it/search/": {
    title: "Cerca | Ricerca svizzera per paraplegici",
    meta: [{
      name: "referrer",
      content: "origin"
    }],
    links: [{
      rel: "canonical",
      href: "/spf/it/search/"
    }]
  },
  "/sportmedizin/it/search/": {
    title: "Cerca | Medicina dello Sport Nottwil",
    meta: [{
      name: "referrer",
      content: "origin"
    }],
    links: [{
      rel: "canonical",
      href: "/sportmedizin/it/search/"
    }]
  },
  "/activecommunication/it/search/": {
    title: "Cerca | Active Communication",
    meta: [{
      name: "referrer",
      content: "origin"
    }],
    links: [{
      rel: "canonical",
      href: "/activecommunication/it/search/"
    }]
  },
  "/sirmed/it/search/": {
    title: "Cerca | Sirmed",
    meta: [{
      name: "referrer",
      content: "origin"
    }],
    links: [{
      rel: "canonical",
      href: "/sirmed/it/search/"
    }]
  },
  "/parahelp/it/search/": {
    title: "Cerca | ParaHelp",
    meta: [{
      name: "referrer",
      content: "origin"
    }],
    links: [{
      rel: "canonical",
      href: "/parahelp/it/search/"
    }]
  },
  "/orthotec/it/search/": {
    title: "Cerca | Orthotec",
    meta: [{
      name: "referrer",
      content: "origin"
    }],
    links: [{
      rel: "canonical",
      href: "/orthotec/it/search/"
    }]
  }
};
var Favicons = function Favicons(param) {
  var domain = param.domain,
    _param_animated = param.animated,
    animated = _param_animated === void 0 ? false : _param_animated;
  var _domain_favicons, _domain_favicons1, _domain_favicons2, _domain_favicons3, _domain_favicons4, _domain_favicons5;
  var waitTimeout = null;
  var animating = false;
  var animatedIconCount = 0;
  var currentFrame = 0;
  // change this key if you want to bust the favicon cache.
  var cacheKey = "g865dgj";
  // Configure the default wait times for each icon in ms.
  var longWait = 30000;
  var normalWait = 600;
  var shortWait = 200;
  // The amount of time to wait before starting the animation.
  var waitBeforeStart = 10000;
  // extracts the current favicon from the domain object.
  var currentFavicon = domain.favicons && "favicon_32" in domain.favicons ? domain.favicons["favicon_32"] : "";
  var blankFavicon = "/img/favicons/_animated/paraplegie_favicon_animation_00.png";
  // Frame animation steps + the wait time before the next animation.
  var animatedIcons = [{
    filename: blankFavicon,
    length: shortWait
  }, {
    filename: currentFavicon,
    length: normalWait
  }, {
    filename: blankFavicon,
    length: shortWait
  }, {
    filename: currentFavicon,
    length: normalWait
  }, {
    filename: blankFavicon,
    length: shortWait
  }, {
    filename: currentFavicon,
    length: longWait
  }];
  // Enable the worker.
  if (setInterval) {
    setInterval(function () {
      animate();
    }, 100);
  }
  /**
  * Remove all the current favicons from the DOM.
  */
  var removeAllCurrentFavicons = function removeAllCurrentFavicons() {
    // Remove the current Favicons
    var currentFavicons = document.querySelectorAll("link[rel='icon'], link[rel='shortcut icon']");
    currentFavicons.forEach(function (faviconElement) {
      faviconElement.remove();
    });
  };
  /**
  * Runs the animation loop, updating the favicons.
  */
  var animate = function animate() {
    if (animating) {
      var currentFavicon = document.getElementById("favicon-animated");
      var currentFaviconSrc = currentFavicon === null || currentFavicon === void 0 ? void 0 : currentFavicon.getAttribute("href");
      var data = animatedIcons[animatedIconCount];
      var src = "".concat(data["filename"], "?cachekey=").concat(cacheKey);
      var length = data["length"];
      // If the current favicon is not the same as the new one, update it.
      if (currentFaviconSrc !== src) {
        // Remove the current Favicons
        removeAllCurrentFavicons();
        // @ts-ignore
        // Add the new favicon to the DOM.
        document.querySelector("head").insertAdjacentHTML("beforeend", '<link id="favicon-animated" rel="icon" href="' + src + '" type="image/png">');
      }
      if (currentFrame * 100 >= length) {
        if (animatedIconCount == animatedIcons.length - 1) {
          animatedIconCount = 0;
        } else {
          animatedIconCount++;
        }
        currentFrame = 0;
      } else {
        currentFrame++;
      }
    }
  };
  // On focus event handler.
  var onFocus = debounce(function () {
    if (animated) {
      if (animating) {
        removeAllCurrentFavicons();
        for (var key in domain.favicons) {
          // @ts-ignore
          var src = domain.favicons[key];
          // @ts-ignore
          document.querySelector("head").insertAdjacentHTML("beforeend", '<link rel="icon" href="' + src + '" type="image/gif">');
        }
      }
      if (waitTimeout) {
        if (clearTimeout) {
          clearTimeout(waitTimeout);
        }
      }
      currentFrame = 0;
      animating = false;
    }
  }, 3);
  // On blur event handler.
  var onBlur = debounce(function () {
    if (animated) {
      // Start the animation 2.5 seconds after blur.
      if (setTimeout) {
        waitTimeout = setTimeout(function () {
          animating = true;
        }, waitBeforeStart);
      }
    }
  }, 3);
  // Enable focus & blur events.
  useEffect(function () {
    window.addEventListener("focus", onFocus);
    return function () {
      return window.removeEventListener("focus", onFocus);
    };
  });
  useEffect(function () {
    window.addEventListener("blur", onBlur);
    return function () {
      return window.removeEventListener("blur", onBlur);
    };
  });
  return /*#__PURE__*/React.createElement(Helmet, null, domain && ((_domain_favicons = domain.favicons) === null || _domain_favicons === void 0 ? void 0 : _domain_favicons.android_chrome_192) && /*#__PURE__*/React.createElement("link", {
    rel: "icon",
    type: "image/png",
    sizes: "192x192",
    href: domain.favicons.android_chrome_192
  }), domain && ((_domain_favicons1 = domain.favicons) === null || _domain_favicons1 === void 0 ? void 0 : _domain_favicons1.android_chrome_192) && /*#__PURE__*/React.createElement("link", {
    rel: "icon",
    type: "image/png",
    sizes: "384x384",
    href: domain.favicons.android_chrome_192
  }), domain && ((_domain_favicons2 = domain.favicons) === null || _domain_favicons2 === void 0 ? void 0 : _domain_favicons2.android_chrome_256) && /*#__PURE__*/React.createElement("link", {
    rel: "icon",
    type: "image/png",
    sizes: "256x256",
    href: domain.favicons.android_chrome_256
  }), domain && ((_domain_favicons3 = domain.favicons) === null || _domain_favicons3 === void 0 ? void 0 : _domain_favicons3.apple_touch_icon) && /*#__PURE__*/React.createElement("link", {
    rel: "apple-touch-icon",
    type: "image/png",
    href: domain.favicons.apple_touch_icon
  }), domain && ((_domain_favicons4 = domain.favicons) === null || _domain_favicons4 === void 0 ? void 0 : _domain_favicons4.favicon_32) && /*#__PURE__*/React.createElement("link", {
    rel: "icon",
    type: "image/png",
    sizes: "32x32",
    href: domain.favicons.favicon_32
  }), domain && ((_domain_favicons5 = domain.favicons) === null || _domain_favicons5 === void 0 ? void 0 : _domain_favicons5.favicon_16) && /*#__PURE__*/React.createElement("link", {
    rel: "icon",
    type: "image/png",
    sizes: "16x16",
    href: domain.favicons.favicon_16
  }), !domain || !domain.favicons && /*#__PURE__*/React.createElement("link", {
    rel: "icon",
    type: "image/png",
    sizes: "16x16",
    href: "/img/favicons/favicon-32x32.png"
  }));
};